import { useEffect } from 'react'

import {
  OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART,
  OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY,
  OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_EVENT,
  OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS,
  OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_EVENT__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION,
  OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION,
  OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_ONBOARDING,
  OPT_WORKFLOWS_LIST_TYPE_ONBOARDING__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY,
  OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE,
  OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN,
  OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN,
  OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES,
  OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE
} from 'Constants'

import { storeGet } from 'Helpers/localStorage'
import { setStatusWorkflowCallback } from 'Pages/WorkflowsList/recoil/callbacks/callbacks'
import { toggleStatusState } from 'Pages/WorkflowsList/recoil/state/search'
import { STORE_KEY_LIST, fromUTCtoZoneFormatted } from 'mailup-react-helpers'

import {
  Badge,
  DataListExtraColumn,
  DataListRow,
  Grid,
  GridCell,
  LINK_VARIANT_HIGHLIGHT,
  Link,
  SPACING_4,
  SpacingVertical,
  TEXT_VARIANT_LIGHT,
  TEXT_VARIANT_SMALL_LIGHT,
  Text,
  Toggle,
  TruncateAndTooltip
} from 'mailup-web-components'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import ActionsMenu from './ActionsMenu'

const Row = ({ item, heads }) => {
  const intl = useIntl()
  const history = useHistory()
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)
  const setStatusTask = useRecoilCallback(setStatusWorkflowCallback, [])

  const { statusToggle } = useRecoilValue(toggleStatusState(item.Id))

  useEffect(() => {
    setStatusTask(item.Id, item.Enabled, true)
  }, [item.Id])

  const handleToggleTestStatus = (e) => {
    setStatusTask(item.Id, e.target.checked, false, item.Type)
  }

  const handleEdit = () => {
    history.push(`/automation/workflow/${item.Id}/edit`)
  }

  const renderTypeName = (type) => {
    switch (type) {
      case OPT_WORKFLOWS_LIST_TYPE_EVENT__VALUE:
        return OPT_WORKFLOWS_LIST_TYPE_EVENT
      case OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE__VALUE:
        return OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE
      case OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION__VALUE:
        return OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION
      case OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION__VALUE:
        return OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION
      case OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY__VALUE:
        return OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY
      case OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN__VALUE:
        return OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN
      case OPT_WORKFLOWS_LIST_TYPE_ONBOARDING__VALUE:
        return OPT_WORKFLOWS_LIST_TYPE_ONBOARDING
      case OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE:
        return OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY
      case OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS__VALUE:
        return OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS
      case OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE:
        return OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART
      case OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE:
        return OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES
      case OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE:
        return OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN
      default:
        return `type: ${type}`
    }
  }

  const COLUMN_AFTER_WIDTH = '30px'

  return (
    <DataListRow data-mu-test='workflows-list-item'>
      <Grid cols={12}>
        <GridCell span={heads[0].span}>
          <>
            <Link
              onClick={handleEdit}
              variant={LINK_VARIANT_HIGHLIGHT}
              data-mu-test={`workflows-list-Name-${item.Id}`}
            >
              <TruncateAndTooltip text={item.Name} />
            </Link>
            <SpacingVertical variant={SPACING_4} />
          </>
          <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
            <TruncateAndTooltip
              text={
                intl.formatMessage({
                  id: 'Load.MailupCommon.Id'
                }) +
                ' ' +
                item.Id +
                (item.Notes ? ' - ' + item.Notes : '')
              }
            />
          </Text>
          <SpacingVertical variant={SPACING_4} />
        </GridCell>
        <GridCell
          span={heads[1].span}
          data-mu-test={`workflows-list-Type-${item.Id}`}
        >
          <Text variant={TEXT_VARIANT_LIGHT}>
            {intl.formatMessage({ id: renderTypeName(item.Type) })}
          </Text>
          <SpacingVertical variant={SPACING_4} />
          {item.CountEmailMessages > 0 && ( // Display if EMAIL
            <>
              <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                {item.CountEmailMessages}{' '}
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.CountMessagesDescription'
                })}
              </Text>
              <SpacingVertical variant={SPACING_4} />
            </>
          )}
          {item.CountSmsMessages > 0 && ( // Display if SMS
            <>
              <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                {item.CountSmsMessages}{' '}
                {intl.formatMessage({
                  id: 'Load.SearchRecipients.smsHeading'
                })}
              </Text>
              <SpacingVertical variant={SPACING_4} />
            </>
          )}
        </GridCell>
        <GridCell
          span={heads[2].span}
          data-mu-test={`workflows-list-LastModifiedDate-${item.Id}`}
        >
          {item.LastModifiedDate &&
            fromUTCtoZoneFormatted(
              item.LastModifiedDate,
              TimeZoneCode,
              'YYYY-MM-DD HH:mm'
            )}
        </GridCell>
        <GridCell
          span={heads[3].span}
          data-mu-test={`workflows-list-LastActivationDate-${item.Id}`}
        >
          {(item.LastActivationDate &&
            fromUTCtoZoneFormatted(
              item.LastActivationDate,
              TimeZoneCode,
              'YYYY-MM-DD HH:mm'
            )) ||
            '-'}
        </GridCell>
        <GridCell span={heads[4].span}>
          {item.Draft ? (
            <Badge
              kind={'secondary'}
              text={intl.formatMessage({
                id: 'Load.AutomationWorkflow.DraftLabel'
              })}
            />
          ) : (
            <Toggle
              checked={statusToggle}
              onChange={handleToggleTestStatus}
              name={`statusToggle-${item.Id}`}
              value='true'
            />
          )}
        </GridCell>
      </Grid>
      <DataListExtraColumn after width={COLUMN_AFTER_WIDTH}>
        <ActionsMenu item={item} moreCountMessage={0} />
      </DataListExtraColumn>
    </DataListRow>
  )
}

export default Row

Row.propTypes = {
  item: PropTypes.object,
  heads: PropTypes.array
}
